import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'FeaturesLogPage.SmartNotificationLogs',
    defaultMessage: 'Smart Notification Logs'
  },
  loading: {
    id: 'FeaturesLogPage.Loading',
    defaultMessage: 'Loading...'
  },
  back: {
    id: 'FeaturesLogPage.Back',
    defaultMessage: `Back to {appName}`
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  }
})
